import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ButtonComponent } from "../button/button.component";
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-active-memberships',
  imports: [ButtonComponent, TranslateModule, NgClass],
  templateUrl: './active-memberships.component.html',
  styleUrl: './active-memberships.component.scss'
})
export class ActiveMembershipsComponent {
  @Input() memberships: any[] = [];
  @Input() membershipId: string | null = null;
  @Output() selectMembership = new EventEmitter<any>();

  lang:string="en";
  constructor(
    private sharedService:SharedService
  ){
    this.lang = this.sharedService.getCurrentLang();
  }
  // This method is used to set selected member ship using m
  setSelectedMemberShip(m: any) {
    this.membershipId = m.CSN;
    this.selectMembership.emit(m);
  }
}
